import { Permission } from '@cims-online/shared'
import { CreateHeaderActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/header'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { DesignSubmittal } from '../../../../DesignSubmittalLogContext/types'

export function useCreateOptions():
  | CreateHeaderActionOptions<DesignSubmittal>
  | undefined {
  const {
    payItemGlobalId,
    fetching,
    createModal: { toggle },
  } = useDesignSubmittalLogContext()
  if (payItemGlobalId) return undefined
  return {
    loading: fetching,
    entity: 'Design Submittal',
    permission: Permission.CreateDesignSubmittal,
    modal: { type: 'custom', toggle },
  }
}
